import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useElementHover } from '@vueuse/core';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  menuItem: any;
  isActive?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderMenuItem',
  props: {
    menuItem: null,
    isActive: { type: Boolean }
  },
  emits: ["set-active-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'set-active-item'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  menuItem: any;
  isActive?: boolean;
};




const menuLink = ref();
const isHoveredLink = useElementHover(menuLink);

const hasChildren = computed(
  () => props.menuItem.children && props.menuItem.children.length,
);

watch(isHoveredLink, (value) => {
  if (value === true) emit('set-active-item');
});

return { __sfc: true,props, emit, menuLink, isHoveredLink, hasChildren, CdnImg }
}

})